import { render, staticRenderFns } from "./KioskWelcomeModal.vue?vue&type=template&id=66afd838&scoped=true"
import script from "./KioskWelcomeModal.vue?vue&type=script&lang=ts"
export * from "./KioskWelcomeModal.vue?vue&type=script&lang=ts"
import style0 from "./KioskWelcomeModal.vue?vue&type=style&index=0&id=66afd838&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66afd838",
  null
  
)

export default component.exports